"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appLyTranslation = exports.getTranslateableFields = void 0;
const traverse_1 = __importDefault(require("traverse"));
const omit_1 = __importDefault(require("lodash/omit"));
const localizedType = '@builder.io/core:LocalizedValue';
function getTranslateableFields(content, sourceLocaleId, defaultInstructions) {
    const results = {};
    let _a = content.data, { blocks, blocksString, state } = _a, customFields = __rest(_a, ["blocks", "blocksString", "state"]);
    if (typeof blocks === 'undefined') {
        blocks = JSON.parse(blocksString);
    }
    // metadata [content's localized custom fields]
    traverse_1.default(customFields).forEach(function (el) {
        var _a;
        if (this.key && el && el['@type'] === localizedType) {
            results[`metadata.${this.path.join('#')}`] = {
                instructions: ((_a = el.meta) === null || _a === void 0 ? void 0 : _a.instructions) || defaultInstructions,
                value: el[sourceLocaleId] || el.Default,
            };
        }
    });
    // blocks
    traverse_1.default(blocks).forEach(function (el) {
        var _a, _b, _c;
        // TODO: localized custom components inputs
        if (el && el.id && ((_a = el.component) === null || _a === void 0 ? void 0 : _a.name) === 'Text' && !((_b = el.meta) === null || _b === void 0 ? void 0 : _b.excludeFromTranslation)) {
            results[`blocks.${el.id}#text`] = {
                value: el.component.options.text,
                instructions: ((_c = el.meta) === null || _c === void 0 ? void 0 : _c.instructions) || defaultInstructions,
            };
        }
    });
    return results;
}
exports.getTranslateableFields = getTranslateableFields;
function appLyTranslation(content, translation, locale) {
    let _a = content.data, { blocks, blocksString, state } = _a, customFields = __rest(_a, ["blocks", "blocksString", "state"]);
    if (typeof blocks === 'undefined') {
        blocks = JSON.parse(blocksString);
    }
    traverse_1.default(customFields).forEach(function (el) {
        var _a;
        const path = (_a = this.path) === null || _a === void 0 ? void 0 : _a.join('#');
        if (translation[`metadata.${path}`]) {
            this.update(Object.assign(Object.assign({}, el), { [locale]: translation[`metadata.${path}`].value }));
        }
    });
    traverse_1.default(blocks).forEach(function (el) {
        var _a, _b;
        // TODO: localized custom components inputs
        if (el &&
            el.id &&
            ((_a = el.component) === null || _a === void 0 ? void 0 : _a.name) === 'Text' &&
            !((_b = el.meta) === null || _b === void 0 ? void 0 : _b.excludeFromTranslation) &&
            translation[`blocks.${el.id}#text`]) {
            this.update(Object.assign(Object.assign({}, el), { meta: Object.assign(Object.assign({}, el.meta), { translated: true }), bindings: Object.assign(Object.assign({}, el.bindings), { 'component.options.text': `state.translation['blocks.${el.id}#text'][state.locale || 'Default'] || \`${el.component.options.text}\`` }) }));
        }
    });
    const translationState = Object.keys(translation).reduce((acc, key) => {
        var _a, _b;
        if (key.startsWith('blocks.')) {
            return Object.assign(Object.assign({}, acc), { [key]: Object.assign(Object.assign({ '@type': localizedType }, (_b = (_a = content.data.state) === null || _a === void 0 ? void 0 : _a.translation) === null || _b === void 0 ? void 0 : _b[key]), { [locale]: translation[key].value }) });
        }
        return acc;
    }, {});
    content.data.state = Object.assign(Object.assign({}, content.data.state), { translation: translationState });
    content.data = Object.assign(Object.assign(Object.assign({}, omit_1.default(content.data, 'blocksString')), { blocks }), customFields);
    return content;
}
exports.appLyTranslation = appLyTranslation;
